import React from 'react';
import { Box, Typography } from '@mui/material';

const hours = Array.from({ length: 24 }, (_, i) => `${i % 12 || 12} ${i < 12 ? 'AM' : 'PM'}`);

const TimeLabels = ({ interval = 1 }) => {
  return (
    <Box
      sx={{
        mt: 0.5,
        display: 'flex',
        justifyContent: 'space-between',
        px: 0.5,
      }}
    >
      {hours.map((hour, i) =>
        i % interval === 0 ? (
          <Typography
            key={i}
            variant="caption"
            sx={{
              color: '#888',
              fontSize: 10,
              textAlign: 'left', whiteSpace: 'nowrap',
              width: `${100 / 24}%`,
            }}
          >
            {hour}
          </Typography>
        ) : (
          <Box key={i} sx={{ width: `${100 / 24}%`, display: 'none', }} />
        )
      )}
    </Box>
  );
};

export default TimeLabels;